import {UI} from "../../../../../stem-core/ui/UIBase.js";
import {styleRule, registerStyle} from "../../../../../stem-core/ui/Style.js";

import {Messages} from "../../../../Messages.js";
import {ConfirmationModal, ConfirmationModalStyle} from "../../../../ui/ConfirmationModal.jsx";
import {Toast} from "../../../../ui/Toast.jsx";
import {NumberInput} from "../../../../../stem-core/ui/input/Input.jsx";
import {Donation, DonationOffer, Currency, Merchant} from "../../../../State.js";
import {MerchantCurrencyInput} from "../../../../common/MerchantCurrencyInput.jsx";
import {apiUpdateDonationAmount} from "../../../../../client/state/DonationStore.js";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";

class EditDonationModalStyle extends ConfirmationModalStyle {
    @styleRule
    amountInput = {
        textTransform: "capitalize",
        fontSize: 16,
    };
}

interface EditDonationModalOptions {
    donation?: Donation;
}

@registerStyle(EditDonationModalStyle)
@autoredraw(Donation)
export class EditDonationModal extends ConfirmationModal<EditDonationModalOptions> {
    declare amount?: any;
    declare amountInput: MerchantCurrencyInput;

    inputChangesMade = false;

    getDefaultOptions() {
        // impure getDefaultOptions? we're in for interesting things to happen..
        return {
            ...super.getDefaultOptions(),
            title: Messages.editDonation,
            confirmAction: () => this.updateDonation(),
        }
    }

    getDescription() {
        const {donation} = this.options;
        const offer = DonationOffer.get(donation.recurringOfferId);
        const merchant = Merchant.get(offer.merchantId);

        return [
            Messages.editDonationDescription(merchant.name, donation.frequency.getFrequencyName()),
            <div>{Messages.donationDashboardUpdateDescription}</div>
        ];
    }

    render() {
        const {donation} = this.options;
        const offer = DonationOffer.get(donation.recurringOfferId);
        const currency = Currency.get(donation.currencyId);
        if (!this.inputChangesMade) {
            this.amount = currency.amountToMainUnits(donation.amount);
        }

        return (
            <MerchantCurrencyInput
                ref="amountInput"
                currency={offer.getCurrency()}
                className={this.styleSheet.amountInput}
                label={Messages.amount}
                InputClass={NumberInput}
                initialValue={this.amount}
                inputAttributes={{
                    type: "tel",
                    min: currency.amountToMainUnits(offer.minAmount),
                    max: currency.amountToMainUnits(offer.maxAmount),
                }}
                onChange={() => {
                    this.inputChangesMade = true;
                    this.amount = this.amountInput.getValue();
                    Toast.hide();
                    this.redraw();
                }}
            />
        );
    }

    async updateDonation() {
        const {donation} = this.options;
        const currency = Currency.get(donation.currencyId);

        let canonicalAmount;
        if (!this.inputChangesMade || (canonicalAmount = currency.mainUnitsToAmount(this.amount)) === donation.amount) {
            Toast.showError(Messages.donationErrorAmountNotChanged);
            return;
        }

        try {
            await apiUpdateDonationAmount(donation, canonicalAmount, donation.coversFees);
            Toast.show(Messages.donationSuccessAmountChanged);
            this.hide();
        } catch (error) {
            Toast.showError(error);
            this.redraw();
        }
    }
}
